/* ==========================================================================
   Cremita de Cereza — comportamiento de la landing dentro del tema Prestige
   Puerto de design/cremita.js. Lo cargan todas las secciones `cremita-*`; el
   navegador deduplica la petición y el archivo se ejecuta una sola vez.

   Cada bloque comprueba que sus elementos existan antes de engancharse, así
   que da igual qué secciones estén puestas en la página: hoy sólo está el
   hero y el resto no hace nada.

   PENDIENTE al portar el bloque de compra: sustituir simularAnadir() por
   POST /cart/add.js y disparar el evento que Prestige escucha para refrescar
   el cart drawer (verificar el nombre exacto en theme.js; no asumirlo).
   ========================================================================== */
function cremitaMontar() {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* -------------------------------------------------- Lettering del hero
     Mide el trazo real y se lo pasa al CSS. Si esto no corre, el CSS ya trae
     la longitud medida (4303) como respaldo y la animación igual funciona. */
  /* El id del trazo es único por sección (lo deriva de `section.id`), así que
     ya no se puede buscar por id fijo: se mide el <path> al que apunta el
     propio <use>. Si el tema renderiza dos letterings, se anima el del hero. */
  var lettering = document.querySelector('.cremita .hero__titulo .lettering');
  if (lettering) {
    var usoLinea = lettering.querySelector('.lettering__linea');
    var trazo = usoLinea && document.querySelector(
      (usoLinea.getAttribute('href') || usoLinea.getAttribute('xlink:href') || '').trim() || '#nada');
    if (trazo && typeof trazo.getTotalLength === 'function') {
      lettering.style.setProperty('--largo', Math.ceil(trazo.getTotalLength()));
    }
    // Sólo animamos si la página se está dibujando de verdad, y siempre con
    // plazo de seguridad: al quitar la clase el estado base es relleno visible,
    // así que ni una pestaña oculta ni un render headless dejan el h1 vacío.
    //
    // Y se espera al velo de carga: encender el neón por debajo de una pantalla
    // opaca gasta la única vez que esa animación se ve. El evento lo dispara el
    // script del <head>, que también garantiza que ocurre (plazo de 4 s).
    var encender = function () {
      if (reduce.matches || document.hidden) return;
      lettering.classList.add('anima');
      setTimeout(function () { lettering.classList.remove('anima'); }, 3400);
    };
    // El velo de carga todavía no está portado: si no existe en el documento,
    // no hay a qué esperar y el letrero se enciende de una vez. Sin esta
    // comprobación el evento nunca llegaría y el neón no correría nunca.
    if (window.cremitaCargado || !document.querySelector('.cremita-velo')) encender();
    else document.addEventListener('cremita:listo', encender, { once: true });
  }

  /* ---------------------------------------------------------------- Toast
     El toast es sólo visual. El anuncio va por regiones vivas separadas que
     ya existen en el DOM: escribir en un elemento oculto no se anuncia, y un
     `aria-live` cambiado en el mismo instante que el texto tampoco es fiable.
     Un fallo de compra va por `role="alert"` (assertive), no por `polite`. */
  var toast = document.getElementById('cremita-toast');
  var toastTexto = toast && toast.querySelector('.toast__texto');
  var avisoAmable = document.getElementById('cremita-aviso-amable');
  var avisoUrgente = document.getElementById('cremita-aviso-urgente');
  var toastTimer;

  function avisar(texto, esError, sinAccion) {
    var region = esError ? avisoUrgente : avisoAmable;
    if (region) { region.textContent = ''; region.textContent = texto; }
    if (!toast) return;
    if (toastTexto) toastTexto.textContent = texto;
    // «Ver el carrito» sólo tiene sentido cuando algo entró al carrito.
    if (esError) toast.setAttribute('data-tipo', 'error');
    else if (sinAccion) toast.setAttribute('data-tipo', 'simple');
    else toast.removeAttribute('data-tipo');
    toast.setAttribute('data-visible', '');
    clearTimeout(toastTimer);
    // El éxito se queda más tiempo: lleva la única salida al carrito.
    toastTimer = setTimeout(function () {
      toast.removeAttribute('data-visible');
    }, esError ? 6000 : 7000);
  }

  /* ------------------------------------------------- Entrada de bloques
     El contenido es visible por defecto. Sólo ocultamos un bloque cuando ya
     sabemos que podemos revelarlo, y siempre con un plazo de seguridad: si el
     medidor no corre (pestaña oculta, render headless), todo vuelve a verse.
     Nunca se condiciona la visibilidad a que una transición ocurra. */
  var bloques = [];
  function revelar(el) { el.removeAttribute('data-oculto'); }

  if (!reduce.matches) {
    bloques = Array.prototype.slice.call(document.querySelectorAll('.cremita .entra'));
    var alto = window.innerHeight;
    bloques.forEach(function (el) {
      if (el.getBoundingClientRect().top > alto * 0.9) el.setAttribute('data-oculto', '');
    });
    // Plazo de seguridad: pase lo que pase, a los 4 s no queda nada oculto.
    setTimeout(function () { bloques.forEach(revelar); bloques = []; }, 4000);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) alScroll();
    });
  }

  /* ------------------------------------------------------- Barra sticky
     Con la estructura de cuatro secciones hay UN solo botón de compra en el
     cuerpo de la página. La barra aparece cuando ese botón termina de salir de
     pantalla y ya no vuelve a esconderse: no hay otro CTA más abajo que pudiera
     duplicar. Antes se ataba al hero y al bloque de cierre; los dos cambiaron.

     Va con un handler de scroll, no con IntersectionObserver: es el elemento
     del que depende la conversión y su estado se puede calcular y comprobar
     directamente. El mismo pase resuelve el revelado y la zona de sonido. */
  var barra = document.getElementById('cremita-barra');

  /* La barra no lleva formulario propio: se ata al de la sección de producto
     por el atributo `form=`, que el Liquid arma con el id de esa sección. En
     una plantilla JSON ese id es `template--<tema>__<clave>` y no se conoce
     hasta que la página existe, así que el ajuste del personalizador puede
     venir vacío y el botón quedaría apuntando a un formulario inexistente:
     una barra que se ve, se pulsa y no compra nada.

     Aquí se comprueba el destino y, si no está, se ata al único formulario de
     compra del cuerpo. Si tampoco lo hay, la barra se retira: mejor sin CTA
     que con uno muerto. */
  if (barra) {
    var botonBarra = barra.querySelector('[data-cremita-anadir]');
    var destino = botonBarra && botonBarra.getAttribute('form');
    if (botonBarra && !(destino && document.getElementById(destino))) {
      var forma = document.querySelector('#cremita-compra form[id^="cremita-compra-"]')
               || document.querySelector('form[id^="cremita-compra-"]');
      if (forma) {
        botonBarra.setAttribute('form', forma.id);
        var envoltura = barra.querySelector('buy-buttons');
        if (envoltura) envoltura.setAttribute('form', forma.id);
      } else {
        barra.remove();
        barra = null;
      }
    }
  }
  var zonaCompra = document.getElementById('cremita-compra');
  var cuerpo = document.body;
  // (la coalescencia se define más abajo, junto a alScroll)

  function medir() {

    var vh = window.innerHeight;

    // Revelar los bloques que ya entraron en pantalla
    if (bloques.length) {
      bloques = bloques.filter(function (el) {
        if (el.getBoundingClientRect().top < vh * 0.92) { revelar(el); return false; }
        return true;
      });
    }

    if (barra && zonaCompra) {
      var c = zonaCompra.getBoundingClientRect();
      if (c.bottom <= 0) barra.setAttribute('data-visible', '');
      else barra.removeAttribute('data-visible');

      /* El control de música flota en la esquina inferior izquierda, que es
         justo por donde pasa el bloque de compra al hacer scroll. En vez de
         taparlo —o de saltar de lado, que desorienta— se sube por encima
         mientras el bloque está en la franja de abajo, con el mismo mecanismo
         que ya lo levanta sobre la barra sticky. Tope de 180 px para que no
         se despegue hasta la mitad de la pantalla. */
      var franja = vh - 96;                       // franja inferior donde vive
      var alza = 0;
      if (c.bottom > franja && c.top < vh) alza = Math.min(180, Math.round(vh - c.top + 12));
      if (alza !== ultimoAlza) {
        ultimoAlza = alza;
        cuerpo.style.setProperty('--alto-compra', alza + 'px');
      }
    }
  }

  /* Coalescencia por tiempo, no por requestAnimationFrame: si un frame se pierde
     (pestaña oculta, render headless) una bandera pendiente se queda encendida y
     la barra no vuelve a medirse nunca. Con temporizadores siempre se recupera,
     y medir tres rectángulos a 60ms es coste despreciable. */
  var ultimaMedida = 0, cola = 0, ultimoAlza = -1;
  function alScroll() {
    var ahora = Date.now();
    clearTimeout(cola);
    if (ahora - ultimaMedida >= 60) { ultimaMedida = ahora; medir(); }
    else cola = setTimeout(function () { ultimaMedida = Date.now(); medir(); }, 60);
  }
  if (!window.cremitaScrollEnganchado) {
    window.cremitaScrollEnganchado = true;
    window.addEventListener('scroll', alScroll, { passive: true });
    window.addEventListener('resize', alScroll, { passive: true });
    window.addEventListener('orientationchange', alScroll);
  }
  medir();

  /* ------------------------------------------------- Kits con variantes
     Un kit bundle deja elegir el tono de cada producto que trae, así que la
     tarjeta tiene un `<select>` por opción y el catálogo de variantes viaja
     con ella en un `<script type="application/json">`. Al cambiar un tono se
     busca la combinación, se escribe el id en el `input[name=id]` —que es lo
     único que `/cart/add.js` mira— y se refrescan precio, estado y botón.

     Dos combinaciones distintas fallan de forma distinta y hay que decirlo
     distinto: la que NO EXISTE (el catálogo no la trae) y la que existe pero
     está AGOTADA. Esconder la diferencia deja a la persona probando tonos sin
     entender por qué no puede comprar.

     No se deshabilitan valores: con dos o tres opciones, ir apagando opciones
     según lo ya elegido puede dejar a alguien en un callejón del que sólo se
     sale volviendo atrás. Se deja elegir y se dice qué pasa. */
  document.querySelectorAll('.cremita [data-cremita-kit]').forEach(function (tarjeta) {
    if (tarjeta.dataset.cremitaEnganchado) return;

    var datos  = tarjeta.querySelector('script[data-cremita-variantes]');
    var campo  = tarjeta.querySelector('[data-cremita-variante]');
    var listas = Array.prototype.slice.call(tarjeta.querySelectorAll('[data-cremita-opcion]'));
    if (!datos || !campo || !listas.length) return;

    var variantes;
    try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
    if (!variantes || !variantes.length) return;

    tarjeta.dataset.cremitaEnganchado = '1';

    var precio = tarjeta.querySelector('[data-cremita-precio]');
    var estado = tarjeta.querySelector('[data-cremita-estado]');
    var boton  = tarjeta.querySelector('[data-cremita-anadir]');
    var diAgotado = tarjeta.getAttribute('data-texto-agotado') || '';
    var diSin     = tarjeta.getAttribute('data-texto-sin') || '';

    /* El orden importa: `variant.options` viene en el orden de las opciones
       del producto, así que los selectores se comparan en ese mismo orden. */
    listas.sort(function (a, b) {
      return (+a.getAttribute('data-cremita-opcion')) - (+b.getAttribute('data-cremita-opcion'));
    });

    function buscar() {
      for (var i = 0; i < variantes.length; i++) {
        var o = variantes[i].o;
        if (!o || o.length !== listas.length) continue;
        var igual = true;
        for (var j = 0; j < listas.length; j++) {
          if (o[j] !== listas[j].value) { igual = false; break; }
        }
        if (igual) return variantes[i];
      }
      return null;
    }

    function poner(el, texto) {
      // Sólo si cambia: `aria-live` anuncia mutaciones, y reescribir lo mismo
      // haría hablar al lector de pantalla sin que haya pasado nada.
      if (el && el.textContent.trim() !== texto) el.textContent = texto;
    }

    function refrescar() {
      var v = buscar();
      var comprable = !!(v && v.d);

      if (boton) boton.disabled = !comprable;
      if (comprable) tarjeta.removeAttribute('data-agotado');
      else tarjeta.setAttribute('data-agotado', '');

      // Sin combinación no hay id que mandar; el botón ya está bloqueado.
      campo.value = v ? v.id : '';
      if (v && v.p) poner(precio, v.p);
      poner(estado, v ? (v.d ? '' : diAgotado) : diSin);
    }

    listas.forEach(function (l) { l.addEventListener('change', refrescar); });
    refrescar();
  });

  /* ----------------------------------------------- Carrusel de kits
     Avanza una tarjeta cada N segundos sobre el propio scroll de la pista:
     nada de transformaciones ni de clonar tarjetas. Así el gesto de deslizar,
     el scroll-snap y la navegación por teclado siguen siendo los del
     navegador, y añadir kits desde el personalizador no pide tocar nada.

     Las flechas hacen el mismo paso que el automático y dan la vuelta en los
     extremos, igual que él. Al pulsarlas se reinicia la cuenta: si no, el
     automático podía saltar medio segundo después del clic y parecer que la
     flecha se había pasado de largo.

     Se para en cuatro situaciones, y las cuatro importan:
       · el puntero encima      — estás leyendo esa tarjeta
       · el foco dentro         — estás navegando con teclado; moverte el sitio
                                  bajo los dedos es de las peores cosas que
                                  puede hacer una página
       · la sección fuera de pantalla — no gastar en animar lo que nadie ve
       · el botón               — WCAG 2.2.2: algo que se mueve solo más de
                                  cinco segundos necesita un mando para pararlo
     Y con «reducir movimiento» activado en el sistema no arranca siquiera. */
  document.querySelectorAll('.cremita [data-cremita-carrusel]').forEach(function (pista) {
    if (pista.dataset.cremitaEnganchado) return;
    pista.dataset.cremitaEnganchado = '1';

    var segundos = parseFloat(pista.getAttribute('data-cremita-carrusel')) || 5;
    var quieto = window.matchMedia('(prefers-reduced-motion: reduce)');
    var porId = '[aria-controls="' + pista.id + '"]';
    var flechas = Array.prototype.slice.call(
      document.querySelectorAll('[data-cremita-carrusel-ir]' + porId));
    var pausa = document.querySelector('[data-cremita-carrusel-pausa]' + porId);
    var ancla = flechas[0] || pausa;
    var mandos = ancla ? ancla.closest('[data-cremita-carrusel-mandos]') : null;

    var reloj = null;
    var pausaPersona = quieto.matches;
    var pausaGesto = false;
    var pausaFuera = false;
    var cabeTodo = false;

    function salto() {
      var t = pista.firstElementChild;
      if (!t) return 0;
      return t.getBoundingClientRect().width + (parseFloat(getComputedStyle(pista).columnGap) || 0);
    }

    function paso(dir) {
      var d = salto();
      if (!d) return;
      var tope = pista.scrollWidth - pista.clientWidth - 2;
      // Da la vuelta en vez de clonar tarjetas: con scroll-snap, el bucle
      // infinito obliga a reposicionar a mano y el salto se nota.
      if (dir > 0 && pista.scrollLeft >= tope) pista.scrollTo({ left: 0, behavior: 'smooth' });
      else if (dir < 0 && pista.scrollLeft <= 2) pista.scrollTo({ left: tope, behavior: 'smooth' });
      else pista.scrollBy({ left: d * dir, behavior: 'smooth' });
    }

    function revisar() {
      var debe = !pausaPersona && !pausaGesto && !pausaFuera && !cabeTodo;
      if (debe && !reloj) reloj = setInterval(function () { paso(1); }, segundos * 1000);
      if (!debe && reloj) { clearInterval(reloj); reloj = null; }
    }

    /* Si las tarjetas caben enteras no hay nada que pasar: se esconden los
       mandos y se para el automático. Se vuelve a mirar al cambiar el tamaño,
       porque cuatro kits caben en un portátil y no en una tablet. */
    function medir() {
      cabeTodo = pista.scrollWidth <= pista.clientWidth + 4;
      if (mandos) {
        if (cabeTodo) mandos.setAttribute('hidden', '');
        else mandos.removeAttribute('hidden');
      }
      revisar();
    }

    flechas.forEach(function (f) {
      f.addEventListener('click', function () {
        paso(parseInt(f.getAttribute('data-cremita-carrusel-ir'), 10) || 1);
        if (reloj) { clearInterval(reloj); reloj = null; revisar(); }
      });
    });

    pista.addEventListener('pointerenter', function () { pausaGesto = true;  revisar(); });
    pista.addEventListener('pointerleave', function () { pausaGesto = false; revisar(); });
    pista.addEventListener('focusin',      function () { pausaGesto = true;  revisar(); });
    pista.addEventListener('focusout', function (e) {
      // `focusout` también salta al moverse ENTRE controles de la propia pista;
      // sin esta comprobación el carrusel se reanudaría a media navegación.
      if (pista.contains(e.relatedTarget)) return;
      pausaGesto = false; revisar();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entradas) {
        pausaFuera = !entradas[0].isIntersecting;
        revisar();
      }, { threshold: 0.2 }).observe(pista);
    }

    if (pausa) {
      if (pausaPersona) pausa.setAttribute('data-pausado', '');
      pausa.addEventListener('click', function () {
        pausaPersona = !pausaPersona;
        if (pausaPersona) pausa.setAttribute('data-pausado', '');
        else pausa.removeAttribute('data-pausado');
        revisar();
      });
    }

    if ('ResizeObserver' in window) {
      /* Hay que observar la pista Y las tarjetas. Sobre la pista sola no basta:
         su caja no cambia cuando lo que se mueve es el contenido, así que
         `scrollWidth` podía pasar de desbordar a caber sin que saltara nada y
         las flechas se quedaban puestas sin tener adónde ir. */
      var ojo = new ResizeObserver(medir);
      ojo.observe(pista);
      Array.prototype.forEach.call(pista.children, function (t) { ojo.observe(t); });
    } else {
      window.addEventListener('resize', medir);
    }

    medir();
  });

  /* ------------------------------------------------------ Añadir al carrito
     NO lo hacemos nosotros. Dentro de Prestige el `<product-form>` de
     `assets/theme.js` ya intercepta el submit, postea a `/cart/add.js`,
     despacha los eventos y refresca el cart drawer. La maqueta simulaba todo
     eso con un `preventDefault()` sobre `form.compra`; aquí eso sería una
     colisión: dos manejadores peleándose por el mismo submit.

     Lo que sí hacemos es ESCUCHAR para pintar los estados del botón. Nunca
     despachamos `cart:change` a mano — el drawer se rompe si alguien lo hace.

     Eventos del tema (verificados en theme.js): variant:add, cart:change,
     cart:error, cart:refresh, cart:prepare-bundled-sections. */
  var botones = document.querySelectorAll('.cremita [data-cremita-anadir]');

  botones.forEach(function (b) {
    if (b.dataset.cremitaEnganchado) return;
    b.dataset.cremitaEnganchado = '1';
    var f = b.form || b.closest('form');
    if (!f) return;
    f.addEventListener('submit', function () {
      // sin preventDefault: el submit sigue su camino hacia <product-form>
      if (b.dataset.estado === 'cargando') return;
      b.dataset.estado = 'cargando';
      b.setAttribute('aria-busy', 'true');
    });
  });

  /* Los botones de UN formulario: los de dentro más los de fuera atados con el
     atributo `form=` (la barra sticky). Pintar todos los de la página sería un
     error visible en cuanto hay kits: añadir uno marcaría los cuatro como «en
     el carrito». */
  function botonesDe(form) {
    if (!form) return [];
    var propios = Array.prototype.slice.call(form.querySelectorAll('[data-cremita-anadir]'));
    if (form.id) {
      Array.prototype.forEach.call(
        document.querySelectorAll('[data-cremita-anadir][form="' + form.id + '"]'),
        function (b) { if (propios.indexOf(b) === -1) propios.push(b); });
    }
    return propios;
  }

  function pintar(lista, estado, etiqueta) {
    lista.forEach(function (b) {
      b.removeAttribute('aria-busy');
      if (estado) b.dataset.estado = estado; else delete b.dataset.estado;
      var e = b.querySelector('[data-etiqueta]');
      if (!e) return;
      if (!b.dataset.etiquetaOriginal) b.dataset.etiquetaOriginal = e.textContent.trim();
      e.textContent = etiqueta || b.dataset.etiquetaOriginal;
    });
  }

  if (!document.cremitaCarritoEnganchado) {
    document.cremitaCarritoEnganchado = true;

    /* La forma del `detail` sale de theme.js:2817-2839, no de suponerla:
       variant:add → { items, cart, onSuccessDo }  ·  items[0].title
       cart:error  → { error }                     ·  el texto de Shopify
       El evento de éxito se despacha sobre EL FORMULARIO y burbujea; el de
       error, también. Por eso los dos se escuchan en `document`. */
    document.addEventListener('variant:add', function (e) {
      var items = e.detail && e.detail.items;
      var nombre = (items && items[0] && items[0].title) || 'El producto';
      // `variant:add` se despacha sobre el formulario y burbujea: e.target ES
      // el formulario que compró, así que sólo se pinta lo suyo.
      pintar(botonesDe(e.target), 'ok', 'En el carrito');
      /* `cart_type` está en «drawer»: el cajón del carrito se abre solo y ES
         la confirmación visual. El aviso va sólo a la región viva, para quien
         no ve abrirse el cajón — sin enlace «ver el carrito», que sería
         redundante con el cajón ya abierto. */
      avisar(nombre + ' quedó en tu carrito.', false, true);
    });

    document.addEventListener('cart:error', function (e) {
      /* El botón NO dice «Reintentar». El error típico aquí es de inventario:
         la variante se agotó entre que se pintó la página y se pulsó. El
         formulario conserva ese mismo id, así que reintentar repite el POST y
         repite el 422 — un callejón. Se marca el estado de error y se deja la
         etiqueta original; quien quiera volver a intentarlo puede, pero no se
         lo prometemos.

         El texto sale de Shopify, que ya lo devuelve en el idioma de la
         tienda; por eso no lo traducimos aquí. */
      var texto = (e.detail && e.detail.error) || '';
      var suyos = botonesDe(e.target);
      pintar(suyos, 'error', null);
      if (texto) avisar(texto, true);
      setTimeout(function () { pintar(suyos, null, null); }, 2400);
    });
  }

  document.querySelectorAll('.cremita [data-avisar]').forEach(function (b) {
    b.addEventListener('click', function () {
      avisar('Te avisamos apenas vuelva. [[PENDIENTE: conectar a la lista de espera]]');
    });
  });

  /* ------------------------------------------------------------ Boletín
     Tampoco lo hacemos nosotros. `{% form 'customer' %}` postea al servidor y
     Shopify RECARGA la página, que vuelve con `form.posted_successfully?` o
     con `form.errors`. Interceptar el submit para enseñar un toast dejaría a
     la persona sin la confirmación real y sin los errores de Shopify (correo
     inválido, ya suscrito). El aviso lo pinta la sección, del lado servidor.

     La validación del formato la hace el navegador con `type="email"` y
     `required`; no hace falta nada más. */

  /* ------------------------------------------------------------- Sonido
     La canción arranca sola y muy baja al levantarse el velo de carga. Eso es
     una intención, no una garantía: sin interacción previa con el dominio los
     navegadores rechazan `play()` con audio audible, y es lo correcto. Cuando
     lo rechazan, el control se queda en «reproducir» y no se insiste ni se
     muestra un aviso —nadie pidió la música, así que un error no es un error.

     El control es fijo y permanente, que es justamente lo que WCAG 1.4.2 pide
     para un audio que empieza solo: hay cómo pararlo desde cualquier punto.

     Dos volúmenes: SUAVE para el arranque automático (ambiente), PLENO cuando
     alguien pulsa el botón (acto deliberado). No hay ducking por sección: con
     el control fuera del hero, atenuar al bajar ya no significaba nada. */
  var boton = document.getElementById('cremita-sonido');
  var pista = document.getElementById('cremita-pista');

  if (boton && pista && !boton.dataset.cremitaEnganchado) {
    boton.dataset.cremitaEnganchado = '1';
    var fuente = pista.dataset.src;
    var SUAVE = 0.12, PLENO = 0.5;
    var encendido = false;
    var hayPista = false;

    // El estado lo dice la etiqueta visible; `data-sonando` es sólo para el CSS.
    function pintar() {
      if (encendido) boton.setAttribute('data-sonando', '');
      else boton.removeAttribute('data-sonando');
    }

    fetch(fuente, { method: 'HEAD' })
      .then(function (r) {
        if (!r.ok) throw 0;
        hayPista = true;
        pista.src = fuente;
        pista.volume = 0;
        arranqueSuave();
      })
      .catch(function () {
        boton.setAttribute('data-pendiente', '');
        console.info('[cremita] Falta ' + fuente + ' — el reproductor queda en estado pendiente.');
      });

    /* Pon esto en false y la música sólo suena si alguien pulsa el botón.
       Es literalmente el interruptor entre las dos políticas posibles. */
    var ARRANQUE_TRAS_GESTO = true;

    /* El arranque automático se intenta una vez, al levantarse el velo. Casi
       siempre lo rechazan: Chrome, Safari y Firefox bloquean el audio audible
       sin interacción previa con el dominio, y hacen bien. Cuando eso pasa —y
       sólo si ARRANQUE_TRAS_GESTO— se queda armado UN disparo para el primer
       gesto real de la persona. Es la única forma de tener música ambiente al
       entrar; a cambio, el sonido aparece en un clic que no lo pedía, y por eso
       el control es permanente y visible desde el primer píxel. */
    function arranqueSuave() {
      function sonar(vol) {
        return pista.play().then(function () {
          encendido = true; pintar();
          rampa(vol);
          return true;
        }).catch(function () {
          encendido = false; pintar();
          return false;
        });
      }
      function intentar() {
        sonar(SUAVE).then(function (ok) {
          if (ok || !ARRANQUE_TRAS_GESTO) return;
          // Bloqueado. Un solo disparo, y sólo con un gesto de verdad: el
          // scroll no cuenta, ni para el navegador ni para nosotros.
          var armado = function (e) {
            quitar();
            if (encendido) return;             // el botón ya lo resolvió
            if (e.target && e.target.closest && e.target.closest('#cremita-sonido')) return;
            sonar(SUAVE);
          };
          function quitar() {
            document.removeEventListener('pointerdown', armado, true);
            document.removeEventListener('keydown', armado, true);
          }
          document.addEventListener('pointerdown', armado, true);
          document.addEventListener('keydown', armado, true);
        });
      }
      if (window.cremitaCargado) intentar();
      else document.addEventListener('cremita:listo', intentar, { once: true });
    }

    /* El control arranca abierto y se recoge al aro a los 6 s. Los primeros
       segundos son cuando la canción acaba de empezar y el nombre importa;
       después el pill estorba, porque la esquina inferior izquierda es por
       donde pasa la columna de compra al hacer scroll. */
    setTimeout(function () { boton.setAttribute('data-compacto', ''); }, 6000);

    boton.addEventListener('click', function () {
      if (!hayPista) {
        avisar('La canción todavía no está cargada. [[PENDIENTE: pista licenciada]]');
        return;
      }
      if (encendido) {
        rampa(0, function () { pista.pause(); });
        encendido = false; pintar();
      } else {
        pista.play().then(function () {
          encendido = true; pintar();
          rampa(PLENO);   // pulsar es un acto deliberado: suena a volumen real
        }).catch(function () {
          avisar('El navegador bloqueó el audio. Vuelve a tocar el botón.', true);
        });
      }
    });

    /* Las rampas se cancelan entre sí. Sin el testigo `mio`, dos toques
       seguidos dejaban al reproductor mintiendo: el `alTerminar` de la rampa de
       salida llamaba a `pause()` DESPUÉS de que la rampa de entrada ya hubiera
       arrancado la pista, y el botón decía «pausar» con el audio en pausa. Además las dos rampas se peleaban por `pista.volume`. */
    var rampaId = 0;
    function rampa(destino, alTerminar) {
      var mio = ++rampaId, hecho = false, dur = 1400;

      function cerrar() {
        if (hecho || mio !== rampaId) return;
        hecho = true;
        pista.volume = destino;
        if (alTerminar) alTerminar();
      }

      if (reduce.matches) { cerrar(); return; }

      /* Plazo duro además del rAF. Si los frames no corren —ventana tapada,
         pestaña en segundo plano, render sin compositor— la rampa se queda
         congelada donde estaba: el botón diría «sonando» con el volumen en 0.
         Es la misma trampa que ya nos costó la barra sticky: nada importante
         puede depender de que llegue un frame. */
      setTimeout(cerrar, dur + 150);

      var desde = pista.volume, t0 = performance.now();
      (function paso(t) {
        if (hecho || mio !== rampaId) return;   // otra rampa tomó el control
        var k = Math.min((t - t0) / dur, 1);
        pista.volume = Math.max(0, Math.min(1, desde + (destino - desde) * (1 - Math.pow(1 - k, 3))));
        if (k < 1) requestAnimationFrame(paso);
        else cerrar();
      })(performance.now());
    }

    // Si la pestaña se oculta, la música se pausa. Nadie quiere audio fantasma.
    document.addEventListener('visibilitychange', function () {
      if (!hayPista) return;
      if (document.hidden && !pista.paused) pista.pause();
      else if (!document.hidden && encendido && pista.paused) pista.play().catch(function () {});
    });
  }

  /* --------------------------------------------------------------- Video
     El hero trae un video de fondo con `autoplay muted loop playsinline`, que
     es la única combinación que los navegadores dejan arrancar sola. Con
     movimiento reducido se pausa y queda el póster: misma composición, sin
     movimiento. Y en una pestaña oculta se pausa, para no decodificar vídeo
     que nadie está viendo. */
  var video = document.querySelector('.cremita .hero__video');
  if (video && !video.dataset.cremitaEnganchado) {
    video.dataset.cremitaEnganchado = '1';
    function ajustarVideo() {
      if (reduce.matches || document.hidden) video.pause();
      else video.play().catch(function () {});   // si falla, queda el póster
    }
    ajustarVideo();
    document.addEventListener('visibilitychange', ajustarVideo);
    if (reduce.addEventListener) reduce.addEventListener('change', ajustarVideo);
  }
}

/* El personalizador del tema recarga secciones sueltas y despacha
   `shopify:section:load` con el nodo nuevo. Si sólo montáramos una vez, al
   editar la sección en el editor el bloque quedaría sin JS enganchado: el
   letrero sin encender, la barra sin medir y el control de música muerto.
   Cada enganche lleva su propio guardia por elemento, así que volver a montar
   es barato y no duplica listeners. */
if (!window.cremitaEnganchado) {
  window.cremitaEnganchado = true;
  document.addEventListener('shopify:section:load', function () { cremitaMontar(); });
  document.addEventListener('shopify:section:unload', function () { cremitaMontar(); });
}
cremitaMontar();
